export const locale = {
    lang: 'es',
    data: {
      'FILEMANAGER': {
        'TITULO': 'Gestor de archivos',
        'SUBTI': 'Cargue los archivos de relevancia para su empresa.',
        'GPTW': {
          'TITULO': 'Seleccione una empresa para ver la lista de archivos cargados',
          'NUMFILES': 'Número de archivos: '
        },
        'CT_NAME':'Colaboradores que sufrieron un acontecimiento traumático severo',
        'LABEL01':'Centros de trabajo',
        'CARGA': {
          'TITULO': 'Presione aquí para cargar un archivo o arrástrelo hasta aquí',
          'CARGANDOTIT': 'Cargando...',
          'CARGANTOTXT': 'El archivo se está enviando a la base de datos. Espere por favor.'
        },
        'MENU': {
          'BOTON': 'Nuevo',
          'ARCHIVO': 'Archivo',
          'CARPETA': 'Carpeta',
          'EXCELTI': 'Descargar Excel TI'
        },
        'LISTA': {
          'TITULOS': {
            'NOMBRE': 'Nombre',
            'EXTEN': 'Extensión',
            'FECHA': 'Fecha de carga',
            'ACCIONES': 'Acciones',
            'TAMANIO': 'Tamaño'
          },
          // Temporales
          'TITULOSENC':{
            'NOMBRE': 'Nombre del colaborador: ',
            'ARCH': 'Nombre del archivo',
            'DATE': 'Fecha de carga',
            'EXTEN': 'Nombre del centro de trabajo: ',
            'ACT':'Acciones',
            'BT':'Inicio'
          },
          'TOOLTIP': {
            'DESCARGA': 'Descargar este archivo',
            'DELETE': 'Eliminar este archivo',
            'OPENFOLDER': 'Haga clic aquí para abrir ésta carpeta',
            'VACIO': 'Esta carpeta está vacía'
          }
        },
        'MENSAJES': {
          'CARGAOK': 'El archivo se almacenó correctamente.',
          'CARGAREP': 'No se pudo cargar este archivo. Ya existe un archivo con el mismo nombre.',
          'DELETERLY': '¿Confirme eliminar este archivo?',
          'DELETEOK': 'El archivo se eliminó correctamente.',
          'CREATEFOLDER': 'Escriba el nombre para la nueva carpeta',
          'FOLDEROK': 'La carpeta se creó correctamente.',
          'archivo_save_4': 'No se pudo crear esta carpeta. Ya existe una carpeta con el mismo nombre.',
          'DELETEFOLDERRLY': '¿Confirma eliminar esta carpeta?\n\nAtención: El contenido de ésta carpeta también será eliminado',
          'DELETEFOLDEROK': 'La carpeta, junto con su contenido se eliminaron correctamente.',
          'INVALID_CHARS': 'El nombre de la carpeta sólo puede contener caracteres de la letra A a la Z y números',
          'BOTONES': {
            'SI': 'Sí',
            'NO': 'No',
            'ACEPTAR': 'Aceptar',
            'CREAR': 'Crear',
            'CANCELAR': 'Cancelar'
          }
        },
        'CARPETASDEFAULT':{
          'Información TI': 'Información TI',
          'Información CA': 'Información CA',
          'Información General': 'Información General',
          'Comunicación NOM-035': 'Comunicación NOM-035',
          'Listado de colaboradores NOM-035': 'Listado de colaboradores NOM-035',
          'PDF de resultados NOM-035':'PDF de resultados NOM-035',
          'Campaña de Comunicación 2020': 'Campaña de Comunicación',
          // 'Culture Audit': 'Culture Audit',
          'Guía de certificación': 'Guía de certificación',
          'Listado de colaboradores': 'Listado de colaboradores',
          'Plantillas': 'Plantillas',
          'Templates con TI': 'Templates con TI',
          'Templates Página': 'Templates Página',
          'Certificar': 'Certificar',
          'Focus Area': 'Focus Area',
          'Medir': 'Medir',
          'Pulsecheck': 'Pulsecheck',
          'Row Data': 'Row Data',
          'Reports': 'Reportes',
          'Campaña de Comunicación 2021 CAYC': 'Campaña de Comunicación 2021 CAYC',

          'Campana de Comunicacion': 'Campaña de Comunicación',
          'Culture Audit': 'Culture Audit™',
          'Great Book': 'Great Book',
          'Cuestionarios': 'Cuestionarios',
          'Pulse Check': 'Pulse Check',
          'Base de datos': 'Base de datos',
          'Practicas For All': 'Prácticas For All',
          'Reporte de Resultados': 'Reporte de Resultados',
          'Validacion': 'Validación',
          'Requerimientos Tecnicos': 'Requerimientos Técnicos',
          'Mock ups Encuesta': 'Mock ups Encuesta'
        }
      }
    }
};
